import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable()
export class SLATargetsService {
  private http = inject(HttpClient);

  private buildUrl(organizationId: number | null, params: any = {}) {
    let url = `${environment.apiUrl}/v1/organization/administrative/organizationslatargets`
    if(organizationId) {
      url += `(${organizationId})/`;
    }
    let httpParams = new HttpParams();
    for (const key in params) {
      if (params.hasOwnProperty(key) && params[key] !== null) {
        httpParams = httpParams.set(key, params[key]);
      }
    }
    return { url, params: httpParams };
  }

  // API Methods for Organization SLA settings
  public getSLATargets(organizationId: number, params?: any) {
    if (!organizationId) {
      throw new Error('Organization ID is required');
    }
    const { url, params: httpParams } = this.buildUrl(organizationId, params);
    return this.http.get<SLATargetsApiResponse>(url);
  }

  public saveSLATargets(organizationId: number, params?: any) {
    if (!organizationId) {
      throw new Error('Organization ID is required');
    }
    const { url, params: httpParams } = this.buildUrl(organizationId, params);
    return this.http.put<SLATargetsApiResponse>(url, httpParams);  // it is an update
  }
}

export interface SLATargetsApiResponse {
  id: number;
  critical: number;
  high: number;
  organization: number;
}
